var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"htmlSnippetContainer"}},[_c('builder-snippet-editor',{attrs:{"header-title":"Edit Email Snippet","snippet-id":_vm.$route.params.id},on:{"load-failure":_vm.showLoadError,"on-save":_vm.handleSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }